import React, { useState, useRef } from "react";
import { Tooltip, TooltipProps } from "react-tippy";
import "react-tippy/dist/tippy.css";
import clsx from "clsx";
import styles from "components/tooltip/tooltip.module.scss";

export type OverflowTooltipProps = Omit<TooltipProps, "title"> & {
	children: any;
	onlyOnLaptop?: boolean;
	showDelay?: number;
	title?: any;
};

const OverflowTooltip: React.FC<OverflowTooltipProps> = ({
	title,
	children,
	className,
	onlyOnLaptop = false,
	showDelay = 400,
	...props
}) => {
	const textRef = useRef<any>();
	const tooltipRef = useRef<any>();
	const isEllipsed = useRef<boolean>(false);
	const showTimer = useRef<any>(null);
	const [isHover, setIsHover] = useState(false);

	const clearShowTimer = () => {
		if (showTimer !== null) {
			clearTimeout(showTimer.current);
			showTimer.current = null;
		}
	};

	const handleMouseEnter = () => {
		const { scrollWidth, offsetWidth } = textRef.current;
		isEllipsed.current = scrollWidth - offsetWidth > 0;

		if (!showDelay) {
			setIsHover(true);
			return;
		}
		showTimer.current = setTimeout(() => {
			setIsHover(true);
			showTimer.current = null;
		}, showDelay);
	};

	const handleMouseLeave = () => {
		clearShowTimer();
		if (!isHover) return;
		setIsHover(false);
	};

	if (!title) return children ?? null;

	const showTooltip = isEllipsed.current && isHover;
	const onlyOnLaptopClass = onlyOnLaptop && styles.onlyOnLaptop;

	return (
		<Tooltip
			ref={tooltipRef}
			title={title}
			position="top"
			theme={"aurora" as any}
			arrow
			sticky={false}
			open={showTooltip}
			{...props}
		>
			<div
				ref={textRef}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				className={clsx(styles.text, className, onlyOnLaptopClass)}
			>
				{children}
			</div>
		</Tooltip>
	);
};

export default OverflowTooltip;
